import request from '@/utils/request'
// 进行中会议签到
const setUserSign = (id) => {
    return request({
        url: `/gathering/meeting/${id}/invitee/sign`,
        method: 'post'
    })
}
// 获取用户签到情况
const getUserSign = (id) => {
    return request({
        url: `/gathering/meeting/${id}/invitee/user/info`,
        method: 'get'
    })
}
// 测试中会议签到
const setTestSign = (id) => {
    return request({
        url: `/gathering/meeting/${id}/invitee/test`,
        method: 'post'
    })
}
// 签名合成文件
const getMeetingSign = (meetingId,fileId) => {
    return request({
        url: `/gathering/meeting/${meetingId}/${fileId}/sign`,
        method: 'get'
    })
}
// 确认签名
const getMeetingConfirmSign = (meetingId,fileId) => {
    return request({
        url: `/gathering/meeting/${meetingId}/${fileId}/confirmSign`,
        method: 'get'
    })
}
export {
    setUserSign,
    getUserSign,
    setTestSign,
	getMeetingSign,
	getMeetingConfirmSign
}